import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromTurnoverList from '../reducers/turnover-list.reducer';

export const selectTurnoverListState = createFeatureSelector<fromTurnoverList.TurnoverListState>(
  fromTurnoverList.turnoverListFeatureKey
);

export const selectTurnoverListSorting = createSelector(selectTurnoverListState, state => state.propertySorting);
export const selectTurnoverListStepState = createSelector(selectTurnoverListState, state => state.showSteps);
export const selectTurnoverListAssigneeState = createSelector(selectTurnoverListState, state => state.stepAssignees);
export const selectTurnoverWidgetsCollapseState = createSelector(selectTurnoverListState, state => state.widgetsState);
